<template>
  <div>
    <el-card></el-card>
  </div>
</template>

<script>
export default {}
</script>

<style lang="less" scoped>
.el-card {
  min-height: 770px;
}
</style>